import React, { useEffect, useCallback } from 'react';   
import { useNotificationSSE } from '../../services/SSE/useServerSentEvent';
import { getToken, getActivityReminderDetails } from '../../Utils/UserFunctions';
import { useDispatch } from 'react-redux';
import { setSSEConnectionStatus, updateReminderData, reminderDismissed, updateMailData } from '../../store/actions/notificationActions';
import { scheduleMailBadgeRefresh } from '../../services/SSE/mailBadgeRefresh';

const SSEConnection = () => {
  const dispatch = useDispatch();
  const accessToken = getToken();

  const handleMessage = useCallback((message) => {
    const { event, data, type, payload } = message;
    
    // Handle new message format (event-based)
    if (event) {
      switch (event) {
        case 'reminder-event':
          if (data && data.id) {
            console.log('SSE reminder-event received:', data.id, data.action_name, data.fire_time);
            if (data.fire_time === true) {
              // Quartz fire: show popup from resolved payload on every tab.
              // Do not rely on reminders/list NextFireTime (already advanced after fire).
              window.dispatchEvent(new CustomEvent('reminder-fire', { detail: data }));
              getActivityReminderDetails();
            } else {
              // create/update/background: list refresh still drives polling popup
              getActivityReminderDetails(() => {
                window.dispatchEvent(new CustomEvent('reminder-updated', { detail: { reminderId: data.id } }));
              });
            }
          }
          break;
        case 'job-monitor-event':
          if (data && data.job_id) {
            window.dispatchEvent(new CustomEvent('job-monitor-updated', { detail: data }));
          }
          break;
        case 'mail-notification-event':
          // Badge only — do not reload Inbox list.
          if (data && data.id) {
            console.log('SSE mail-notification-event (badge):', data.id, data.subject);
            scheduleMailBadgeRefresh();
          }
          break;

        default:
          console.log('Unknown SSE event type:', event);
      }
      return;
    }
    
    // Handle legacy message format (type-based)
    switch (type) {
      case 'REMINDER':
        if (payload && payload.action) {
          if (payload.action === 'new' || payload.action === 'update') {
            const currentReminders = JSON.parse(localStorage.getItem('ACTIVITY_REMINDER') || '{}');
            const reminderKey = payload.data?.key || payload.data?.id;
            if (reminderKey) {
              currentReminders[reminderKey] = payload.data;
              localStorage.setItem('ACTIVITY_REMINDER', JSON.stringify(currentReminders));
              dispatch(updateReminderData({ [reminderKey]: payload.data }));
              getActivityReminderDetails();
            }
          } else if (payload.action === 'dismiss') {
            const currentReminders = JSON.parse(localStorage.getItem('ACTIVITY_REMINDER') || '{}');
            delete currentReminders[payload.data?.id];
            localStorage.setItem('ACTIVITY_REMINDER', JSON.stringify(currentReminders));
            dispatch(reminderDismissed(payload.data?.id));
            getActivityReminderDetails();
          }
        }
        break;

      case 'MAIL':
        if (payload && payload.action === 'new') {
          dispatch(updateMailData({ 
            newMailCount: payload.count || 1,
            hasNewMail: true 
          }));
        }
        break;

      case 'NOTIFICATION':
      case 'MESSAGE':
        // Generic notification handling can be added here
        break;

      default:
        console.log('Unknown SSE message type:', type || event);
    }
  }, [dispatch]);

  const handleError = useCallback((error) => {
    console.error('SSE Error:', error);
    if (error.message && error.message.includes('401')) {
      // Handle unauthorized - could dispatch logout
    }
  }, []);

  const status = useNotificationSSE(accessToken, handleMessage, handleError);

  useEffect(() => {
    dispatch(setSSEConnectionStatus(status));
  }, [status, dispatch]);

  return null;
};

export default SSEConnection;


